import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirplaneSolidIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirplaneSolidGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M10.6815 21.1757C10.9769 21.6923 11.507 22 12.1014 22L12.1113 22C12.7094 21.9963 13.2402 21.6824 13.5318 21.1597L14.1379 20.071C14.3554 19.678 14.4704 19.2344 14.4704 18.7883V14.0998L20.3643 11.8779C20.6108 11.7852 20.774 11.5492 20.774 11.286V8.89725C20.774 8.71189 20.6924 8.53518 20.5509 8.4153C20.4094 8.2942 20.2222 8.23736 20.0393 8.2732L14.4704 9.18147V6.20207L16.0478 5.07012C16.2134 4.95148 16.3116 4.75994 16.3116 4.55604V2.6332C16.3116 2.43424 16.2177 2.24642 16.0583 2.12654C15.8989 2.00667 15.6919 1.97208 15.5016 2.02521L12.136 3.00764L8.67465 2.02398C8.48372 1.96961 8.27921 2.00915 8.12041 2.12778C7.96223 2.24765 7.86893 2.43424 7.86893 2.6332V4.55604C7.86893 4.76242 7.96965 4.95519 8.13833 5.07382L9.71021 6.17735V9.15676L4.13819 8.27196C3.95159 8.246 3.7687 8.29544 3.62782 8.41654C3.48694 8.5364 3.40601 8.71189 3.40601 8.89725V11.286C3.40601 11.5504 3.57098 11.7877 3.81999 11.8791L9.71023 14.0504V18.7759C9.71023 19.2356 9.83071 19.6891 10.0587 20.0858L10.6815 21.1757Z"
        fill="#FC3B26"
      />
    </svg>
  );
};

export default AirplaneSolidIcon;
